import { render, staticRenderFns } from "./CounterRounded.vue?vue&type=template&id=f01892c8"
import script from "./CounterRounded.vue?vue&type=script&lang=js"
export * from "./CounterRounded.vue?vue&type=script&lang=js"
import style0 from "./CounterRounded.vue?vue&type=style&index=0&id=f01892c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports